import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, FormControlLabel, Switch, Typography, CircularProgress } from '@mui/material';
import axiosInstance from '../../services/axiosInstance';

/**
 * Opt-in preferences for mock interview email / reminders (MI-WS-06).
 */
export default function MockInterviewNotificationPrefs() {
  const [prefs, setPrefs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const {
          data
        } = await axiosInstance.get('/notifications/preferences');
        if (!cancelled) setPrefs(data.preferences?.mockInterview || {
          inApp: true,
          email: false,
          reminders: true
        });
      } catch (err) {
        if (!cancelled) setError(err?.response?.data?.message || 'Failed to load preferences');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const update = key => e => {
    setPrefs(prev => ({
      ...prev,
      [key]: e.target.checked
    }));
    setSaved(false);
  };
  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      const {
        data
      } = await axiosInstance.patch('/notifications/preferences', {
        mockInterview: prefs
      });
      setPrefs(data.preferences?.mockInterview || prefs);
      setSaved(true);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to save preferences');
    } finally {
      setSaving(false);
    }
  };
  if (loading) {
    return <Box sx={{
      py: 2
    }}>
        <CircularProgress size={22} />
      </Box>;
  }
  return <Box>
      <Typography variant="subtitle2" sx={{
      mb: 1
    }}>
        Mock interview notifications
      </Typography>
      {error ? <Alert severity="error" sx={{
      mb: 1
    }}>{error}</Alert> : null}
      {saved ? <Alert severity="success" sx={{
      mb: 1
    }}>Preferences saved.</Alert> : null}
      <FormControlLabel control={<Switch checked={Boolean(prefs?.inApp)} onChange={update('inApp')} />} label="In-app notifications" />
      <FormControlLabel control={<Switch checked={Boolean(prefs?.reminders)} onChange={update('reminders')} />} label="Interview reminders" />
      <FormControlLabel control={<Switch checked={Boolean(prefs?.email)} onChange={update('email')} />} label="Email notifications (opt-in)" />
      <Box sx={{
      mt: 1
    }}>
        <Button size="small" variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : 'Save preferences'}
        </Button>
      </Box>
    </Box>;
}
